module.exports = __webpack_public_path__ + "img/lock.4d719f05.svg";